<template>
  <view-wrapper
    :show-back-button="false"
    :name="title"
    :loading="loading"
    loading-text="Getting articles"
  >
    <FeatureZone features="quickPrintEnabled" v-if="$route.params.labelId">
      <g-button
        class="flex items-center mb-4 ml-auto primary"
        @click="openQuickPrintModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
          />
        </svg>
        Print
      </g-button>
    </FeatureZone>
    <!-- <section
      v-if="activeConnector && activeConnector.id != null"
      class="flex items-start mb-10">
      <div class="w-64">
        <g-button
            class="flex items-center primary"
            @click="openUserGroupsModalOpen"
          >User Groups</g-button>
        </div>
    </section> -->
    <div class="flex justify-end mb-4">
      <ArticleSortBy :options="sortOptions" v-model="sortState" />
    </div>
    <filter-and-sort-box
      :data="sortedArticles"
      :headers="headers"
      :use-search="true"
      :disable-sort="true"
      @searchQuery="onSearch"
    >
      <template v-slot:d="{ d }">
        <td
          class="relative py-1"
          v-for="(key, index) in getKeys(d)"
          :key="key + index"
          @click="printArticle(d)"
        >
          <div
            class="w-full py-4 pl-4 bg-primary-light"
            v-if="Array.isArray(d[key])"
          >
            <span v-for="(item, index) in d[key]" :key="index">
              {{ item.name }}<span v-if="index < d[key].length - 1">,</span>
            </span>
          </div>
          <div
            class="w-full py-4 pl-4 bg-primary-light"
            :class="{
              'rounded-l': index === 0,
              'rounded-r': Object.keys(headers).length - 1 === index,
            }"
            v-else
          >
            <span v-if="key != 'modified'" class="inline-block w-10/12">{{
              d[key] ? d[key] : ""
            }}</span>
            <span v-if="key == 'modified'" class="inline-block w-10/12">{{
              d[key] ? formatDate(d[key]) : ""
            }}</span>
            <i
              v-if="Object.keys(headers).length - 1 === index"
              class="p-1 mt-1 mr-1 arrow right"
            />
          </div>
        </td>
      </template>
    </filter-and-sort-box>
    <div class="py-2">
      <div class="float-right">
        <i
          class="p-1 mx-1 mt-1 cursor-pointer arrow left"
          @click="setPage(page - 1)"
        />
        <span class="select-none">Page {{ page }}</span>
        <i
          class="p-1 mx-1 mt-1 cursor-pointer arrow right"
          @click="setPage(page + 1)"
        />
      </div>
    </div>
    <modal v-if="isUserGroupsModalOpen" @close="isUserGroupsModalOpen = false">
      <template slot="header">
        <img src="../../assets/images/printer.svg" alt="printer" />
      </template>
      <template slot="body">
        <h4>Select one or more user groups</h4>
        <wrapper>
          <div
          class="pt-1 flex text-white"
          v-for="(userGroup, i) in availableUserGroups"
          :key="'userGroup' + i"
        >
          <Checkbox
            class="m-1"
            :value="userGroups.includes(userGroup.id)"
            @input="addRemoveUserGroup(i, userGroup.id)"
          />
          <div
            class="cursor-pointer select-none"
            @click="addRemoveUserGroup(i, userGroup.id)"
          >
            <span class="block pl-5">{{ userGroup.name }}</span>
          </div>
        </div>
        </wrapper>
      </template>

      <template slot="buttons">
        <g-button
          class="flex items-center m-auto mt-4 primary"
          @click="isUserGroupsModalOpen = false"
        >Close</g-button>
      </template>

    </modal>
    <modal v-if="isQuickPrintModalOpen" @close="isQuickPrintModalOpen = false">
      <template slot="header">
        <img src="../../assets/images/printer.svg" alt="printer" />
      </template>
      <template slot="body">
        <h4>Scan a barcode or enter an external identifier to quickprint</h4>
        <wrapper>
          <g-input
            ref="identifier"
            name="External Identifier"
            v-model="externalIdentifier"
            label-placeholder="External Identifier"
            @keyup.native.enter="sendQuickPrint"
            autocomplete="off"
          ></g-input>
        </wrapper>
      </template>
      <template slot="buttons">
        <g-button
          class="flex items-center m-auto mt-4 primary"
          @click="sendQuickPrint"
        >
          <svg
            v-if="!isPrinting"
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span
            v-if="isPrinting"
            class="w-3 h-3 mr-2 border-4 border-solid small-spinner-animation"
          ></span>

          Print
        </g-button>
      </template>
    </modal>
    <modal
      v-if="errorMessage && errorMessage.length"
      type="warning"
      @close="errorMessage = null"
    >
      <template slot="body">
        <h2>Error</h2>
        <p>{{ errorMessage }}</p>
      </template>
    </modal>
  </view-wrapper>
</template>

<script>
import { BehaviorSubject, combineLatest } from "rxjs";
import { debounceTime, distinctUntilChanged, mapTo } from "rxjs/operators";
import { sendToPrinterService } from "../../utils/printerHelpers";

import GButton from "../../components/forms/Button.vue";
import GInput from "../../components/forms/Input.vue";
import Checkbox from "../../components/forms/Checkbox.vue";
import FilterAndSortBox from "../../components/FilterAndSortBox";
import { formatDate } from "../../utils/dateHelpers";
import Modal from "../../components/Modal.vue";
import FeatureZone from "../../components/FeatureZone.vue";
import ArticleSortBy from "../../components/ArticleSortBy.vue";
import {
  ARTICLE_NAME_SORT_KEY,
  SORT_ASCENDING,
  buildSortOptions,
  sortArticles,
  getFlatArticleKeys,
  getFlatArticleValue,
} from "../../utils/articleSortHelper";

export default {
  components: {
    FilterAndSortBox,
    GButton,
    GInput,
    Modal,
    FeatureZone,
    Checkbox,
    ArticleSortBy,
  },
  data: () => ({
    loading: false,
    articles: [],
    headers: {
      name: "Article name",
      externalid: "External id",
      modified: "Modified",
    },
    page: 1,
    pageSize: 10,
    searchQuery: null,
    pageNumber$: null,
    pageSize$: null,
    searchQuery$: null,
    isQuickPrintModalOpen: false,
    isUserGroupsModalOpen: false,
    activeConnector: null,
    userGroups: [],
    availableUserGroups: [],
    externalIdentifier: "",
    isPrinting: false,
    printQueues: null,
    errorMessage: null,
    sortState: {
      sortKey: ARTICLE_NAME_SORT_KEY,
      direction: SORT_ASCENDING,
    },
  }),
  computed: {
    title() {
      if (this.$route.params.labelId) return "Select article";
      if (this.activeConnector && this.activeConnector.id) return "Connector articles";

      return "My articles";
    },
    sortOptions() {
      return buildSortOptions(this.articles, getFlatArticleKeys);
    },
    sortedArticles() {
      return sortArticles(
        this.articles,
        this.sortState.sortKey,
        this.sortState.direction,
        getFlatArticleValue
      );
    },
  },
  methods: {
    async getArticles(searchQuery, page, pageSize) {
      this.loading = true;
      let response;

      const settingsResponse = await this.$store.$api.get("/api/subscription");
      if(settingsResponse.data.data.activeConnector && settingsResponse.data.data.activeConnector.id) {
        this.activeConnector = settingsResponse.data.data.activeConnector;
        response = await this.$store.$api.get(
          `/api/connectors/${this.activeConnector.id}/articles?take=${pageSize}&offset=${pageSize *(page - 1)}&searchQuery=${searchQuery}`
        );

        const userGroupResponse = await this.$store.$api.get('/api/groups');
        this.availableUserGroups = userGroupResponse.data.data;
        this.userGroups = this.availableUserGroups.map(ug => ug.id);

      } else if (this.$route.params.labelId) {
        response = await this.$store.$api.get(
          `/api/labels/${
            this.$route.params.labelId
          }/articles?take=${pageSize}&offset=${pageSize *
            (page - 1)}&searchQuery=${searchQuery}`
        );
      } else {
        response = await this.$store.$api.get(
          `/api/articles?take=${pageSize}&offset=${pageSize *
            (page - 1)}&searchQuery=${searchQuery}`
        );
      }
      this.articles = response.data.data;
      this.loading = false;
    },
    getKeys(order) {
      return Object.keys(order).filter(key => {
        return key !== "id";
      });
    },
    formatDate,
    printArticle(article) {
      if (this.$route.params.labelId && this.activeConnector && this.activeConnector.id) {
        if(this.userGroups == null || this.userGroups.length == 0) {
          this.errorMessage = "Select at least one user group";
          return;
        }
        const groups = this.userGroups.length > 1
           ? this.userGroups.map(g => `groups=${g}`).join('&')
           : `groups=${this.userGroups[0]}`;
        this.$router.push(
          `/print-labels/${this.$route.params.labelId}/article/${article.id}/${this.activeConnector.id}?${groups}`
        );
      } else if (this.$route.params.labelId) {
        this.$router.push(
          `/print-labels/${this.$route.params.labelId}/article/${article.id}`
        );
      } else if(this.activeConnector && this.activeConnector.id){
        if(this.userGroups == null || this.userGroups.length == 0) {
          this.errorMessage = "Select at least one user group";
          return;
        }
        const groups = this.userGroups.length > 1
           ? this.userGroups.map(g => `groups=${g}`).join('&')
           : `?groups=${this.userGroups[0]}`;
        this.$router.push(`/print-article/${article.id}/${this.activeConnector.id}?${groups}`);
      }
      else {
        this.$router.push("/print-article/" + article.id);
      }
    },
    setPage(newPage) {
      this.pageNumber$.next(Math.max(1, newPage));
    },
    onSearch(value) {
      this.searchQuery$.next(value);
    },
    addRemoveUserGroup(index, id) {
      const i = this.userGroups.indexOf(id);
      if (i === -1) {
        this.userGroups.push(id);
      } else {
        this.userGroups.splice(i, 1);
      }
    },
    openUserGroupsModalOpen() {
      this.isUserGroupsModalOpen = true;
    },
    openQuickPrintModal() {
      this.isQuickPrintModalOpen = true;
      this.externalIdentifier = "";
      this.$nextTick(() => this.$refs.identifier.$refs.input.focus());
    },
    async sendQuickPrint() {
      this.isPrinting = true;
      if (!this.printQueues) {
        this.printQueues = await this.$store.dispatch(
          "SETTINGS/GET_PRINT_QUEUES"
        );
      }

      let printFile = null;

      try {
        var computerName = this.printQueues && this.printQueues.computerName;
        const response = await this.$store.$api.post(
          "/api/printjobs/quickprint",
          {
            externalIdentifier: this.externalIdentifier,
            labelId: this.$route.params["labelId"],
            computerName: computerName,
            quantity: 1,
            readLatestOrder: false,
          }
        );

        printFile = response.data.data;
        const printerHelperUri = this.$store.getters[
          "SETTINGS/PRINTER_HELPER_URI"
        ];

        await sendToPrinterService(printerHelperUri, {
          targetAddress: printFile.targetIpAddress,
          port: printFile.targetPort,
          targetPrintQueue: printFile.targetPrintQueue,
          printerFileUrl: printFile.printFileName,
          useLocalPrinterDriver: printFile.useLocalPrinterDriver,
          pdfAsBase64String: printFile.pdfAsBase64String,
          orientation: printFile.orientation,
          scale: printFile.scale,
          side: printFile.side,
          paperSize: printFile.paperSize,
          customPaperSize: printFile.customPaperSize,
        });

        await this.$store.dispatch("PRINTJOBS/UPDATE_PRINTJOBENTRY_STATUS", {
          printJobEntryId: printFile.printJobEntryId,
          status: "Success",
        });
      } catch (error) {
        let message;

        if (error.response) {
          message = error.response.data;
        } else if (error.message) message = error.message;

        this.errorMessage = message;

        if (printFile) {
          await this.$store.dispatch("PRINTJOBS/UPDATE_PRINTJOBENTRY_STATUS", {
            printJobEntryId: printFile.printJobEntryId,
            status: "Error",
            message: "Could not print using printerhelper",
          });
        }
      }
      this.externalIdentifier = "";
      this.isPrinting = false;
    },
  },
  async mounted() {
    this.pageNumber$ = new BehaviorSubject(1);
    this.pageNumber$$ = this.pageNumber$.subscribe(
      value => (this.page = value)
    );

    this.searchQuery$ = new BehaviorSubject("");
    this.searchQuery$$ = this.searchQuery$
      .pipe(
        distinctUntilChanged(),
        mapTo(1)
      )
      .subscribe(value => {
        this.pageNumber$.next(value);
      });
    this.pageSize$ = new BehaviorSubject(10);

    this.searchStream$$ = combineLatest(
      this.searchQuery$.pipe(distinctUntilChanged()),
      this.pageNumber$.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ),
      this.pageSize$
    )
      .pipe(debounceTime(300))
      .subscribe(([searchQuery, pageNumber, pageSize]) => {
        this.getArticles(
          encodeURIComponent(searchQuery || ""),
          pageNumber,
          pageSize
        );
      });
  },
  beforeDestroy() {
    this.pageNumber$$.unsubscribe();
    this.searchQuery$$.unsubscribe();
    this.searchStream$$.unsubscribe();
  },
};
</script>

<style scoped>
.small-spinner-animation {
  border-color: rgba(255, 255, 255, 0.25);
  border-top-color: rgba(255, 255, 255, 1);
  border-radius: 50%;
  animation: smallSpinnerRotation 0.6s infinite linear;
}

@keyframes smallSpinnerRotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
